// @ts-nocheck
import { Routes, Route } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Toaster } from '@/components/ui/toaster'
import AnamnesePage from '@/pages/anamnese/[token]/index'
import AnamneseCompletaPage from '@/pages/anamnese/completo/index'
import AnamneseExpiradaPage from '@/pages/anamnese/expirado/index'
import AnamneseCanceladaPage from '@/pages/anamnese/cancelado/index'
import AcessoNegadoPage from '@/pages/anamnese/AcessoNegadoPage'

function SuccessPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Formulário Enviado!</h2>
          <p className="text-gray-600 mb-6">
            Seus dados foram enviados com sucesso para triagem. Nossa equipe analisará as informações e entrará em contato em breve.
          </p>
          <Button onClick={() => window.location.href = '/'} className="w-full">
            Voltar ao Início
          </Button>
        </div>
      </div>
    </div>
  )
}

export default function AnamneseApp() {
  return (
    <>
      <Routes>
        <Route path="/anamnese/expirado" element={<AnamneseExpiradaPage />} />
        <Route path="/anamnese/cancelado" element={<AnamneseCanceladaPage />} />
        <Route path="/anamnese/sucesso" element={<SuccessPage />} />
        <Route path="/anamnese/completo" element={<AnamneseCompletaPage />} />
        <Route path="/anamnese/:token" element={<AnamnesePage />} />
        <Route path="/:token" element={<AnamnesePage />} />
        <Route path="/" element={<AcessoNegadoPage />} />
      </Routes>
      <Toaster />
    </>
  )
}
